import { Col } from 'react-bootstrap';
import styled from 'styled-components';
import Collapse from 'components/collapse/Collapse';

// Stock .form-control height. Controls that sit in a field row match it so the rows line up.
export const FIELD_HEIGHT = '34px';

export const DirectBookingEngineContainer = styled.div`
  .nav > li > a {
    padding: 10px;
  }
`;

// The flex context matters: a form-group holding only floated label/input columns
// collapses to zero height in a block parent, which swallows the gap between fields.
export const SettingsColumnStyled = styled(Col).attrs({
  md: 6,
  sm: 12,
  xs: 12,
})`
  display: flex;
  flex-direction: column;
`;

export const SettingsSectionStyled = styled(Collapse)`
  &:not(:first-child) {
    margin-top: 20px;
  }

  // Vertical-only resize keeps the width pinned to the column, and the bounds hold
  // the drag to roughly 4–12 rows around the initial 6.
  textarea {
    max-height: 260px;
    min-height: 90px;
    resize: vertical;
  }

  .featured-properties-field .input-group > div {
    contain: inline-size;
  }
`;

export const FormFooterStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px 0;
`;
